import type { FC } from "react";

import { EditOrgUserForm } from "components/forms/EditOrgUserForm";
import type { OrgUserType, UserType } from "components/server-types";
import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";

type EditOrgUserModalProps = {
  user: UserType;
  orgUser: OrgUserType;
  open: boolean;
  onClose: () => void;
};

export const EditOrgUserModal: FC<EditOrgUserModalProps> = ({ user, orgUser, open, onClose }) => (
  <Dialog open={open} title={t("user_options_menu.edit_user_info.title")} onClose={onClose}>
    <EditOrgUserForm className="pt-5" orgUser={orgUser} user={user} onClose={onClose} />
  </Dialog>
);
